import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Statically bundled locales — keeps the t() call sites working without an
// HTTP backend. Avoids 404s on /locales/en/translation.json and the noisy
// debug output i18next-http-backend produces when a file is missing.
import appShell from './locales/en/app-shell.json';
import appShellFr from './locales/fr/app-shell.json';
import advisorFr from './locales/fr/advisor.json';
import settingsFr from './locales/fr/settings.json';
import auth from './locales/en/auth.json';
import authFr from './locales/fr/auth.json';
import custodianProfiles from './locales/en/custodian-profiles.json';
import custodianProfilesFr from './locales/fr/custodian-profiles.json';
import definitionForm from './locales/en/definition-form.json';
import definitionFormFr from './locales/fr/definition-form.json';
import rebalancingSchedule from './locales/en/rebalancing-schedule.json';
import rebalancingScheduleFr from './locales/fr/rebalancing-schedule.json';
import securitySelection from './locales/en/security-selection.json';
import securitySelectionFr from './locales/fr/security-selection.json';
import startingUniverse from './locales/en/starting-universe.json';
import startingUniverseFr from './locales/fr/starting-universe.json';
import strategies from './locales/en/strategies.json';
import strategiesFr from './locales/fr/strategies.json';
import weightingMethod from './locales/en/weighting-method.json';
import weightingMethodFr from './locales/fr/weighting-method.json';
import custodianCollections from './locales/en/custodian-collections.json';
import custodianCollectionsFr from './locales/fr/custodian-collections.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'app-shell',
  ns: [
    'custodian-collections',
    'advisor',
    'settings',
    'app-shell',
    'auth',
    'custodian-profiles',
    'definition-form',
    'rebalancing-schedule',
    'security-selection',
    'starting-universe',
    'strategies',
    'weighting-method',
  ],
  resources: {
    fr: {
      'custodian-profiles': custodianProfilesFr,
      'custodian-collections': custodianCollectionsFr,
      'app-shell': appShellFr,
      advisor: advisorFr,
      settings: settingsFr,
      auth: authFr,
      'definition-form': definitionFormFr,
      strategies: strategiesFr,
      'weighting-method': weightingMethodFr,
      'security-selection': securitySelectionFr,
      'starting-universe': startingUniverseFr,
      'rebalancing-schedule': rebalancingScheduleFr,
    },
    en: {
      'custodian-profiles': custodianProfiles,
      'custodian-collections': custodianCollections,
      'app-shell': appShell,
      auth,
      'definition-form': definitionForm,
      'rebalancing-schedule': rebalancingSchedule,
      'security-selection': securitySelection,
      'starting-universe': startingUniverse,
      strategies,
      'weighting-method': weightingMethod,
    },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
